import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import icon from './plus-icon.svg';

export class AddMinitableChartPlugin extends Plugin {
  init() {
    const editor = this.editor;
    const withText = editor.config.get('toolbar.shouldShowMiniTableText');

    editor.ui.componentFactory.add('addMinitableChart', (locale) => {
      const view = new ButtonView(locale);

      view.set({
        label: 'Add mini-table/chart',
        tooltip: true,
        withText,
        icon,
      });

      const richTextEditor = document.querySelector('#rich-text-editor');

      view.on('execute', () => {
        const event = new CustomEvent('inserting-minitable-chart');

        richTextEditor.dispatchEvent(event);

        if (this.PWCIngestionService) {
          this.PWCIngestionService.executeInsertMiniTable(editor);
        }
      });

      return view;
    });
  }
}
